import useLoad from '../../../../components/hooks/useLoad';

function useLoadProfilesToRequirement() {
  return useLoad('api/Profile/ProfileWithoutDeleting', 'iD_Profile', {});
}

export default useLoadProfilesToRequirement;
